import "@hotwired/turbo-rails"
import "./controllers"
import "./custom_confirm"
import Chartkick from "chartkick"
import "chartkick/chart.js"
Chartkick.options = { nonce: true }
